import { ConfirmEmailForm } from '@features/auth/confirm-email';

import { createView } from '@shared/lib/view';

const ConfirmEmailTimeoutPage = createView(ConfirmEmailForm)
  .props({ timeout: true })
  .view();

export { ConfirmEmailTimeoutPage };
